import { Drawer, List, ListItem } from '@mui/material'
import React from 'react'

const Sidebar = () => {
  return (
    <Drawer variant='persistent'  anchor="right" >
      <List>
        <ListItem>
            crush one 
        </ListItem>
        <ListItem>
            crush two
        </ListItem>
      </List>
    </Drawer>
  )
}

export default Sidebar